import React, { useEffect } from "react";
import Brandlogo from "../Components/Brandlogo";
import { Counter } from "../Components/Counter";
import { Homepagebanner } from "../Components/Homepagebanner";
import ScrollAnimation from "react-animate-on-scroll";
import { Homesignage } from "../Components/Homesignage";
import  Ourwork  from "../Components/Ourwork";
import VMBrandLogos from "../Components/VMBrandLogos";
import MagicInfo from "../Components/MagicInfo";
import magicInfoData from "../Components/MagicInfoData";
import InfoSection from "../Components/InfoSection";
import InfoSectionData from "../Components/InfoSectionData";
import Workdetails from "../Components/Workdetails";

export const Home = () => {
  useEffect(() => {
    document.title = "Digital Signage | Home";
  });
  return (
    <>
      <Homepagebanner />
      <Brandlogo />
      <VMBrandLogos />

      <div className="site-main">
        <section className="prt-row about-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 col-sm-12">
                <ScrollAnimation animateIn="zoomIn">
                  <div className="section-title">
                    <div className="title-header">
                      <h2 className="title text-center">
                        Why Does Digital Signage Matter?
                      </h2>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
              <div className="col-lg-5 col-md-12">
                <ScrollAnimation animateIn="zoomIn">
                  <div className="section-title">
                    <div className="title-desc">
                      <p style={{ textAlign: "justify" }}>
                        In the world loaded with information traditional
                        advertising methods generally failed to capture the
                        attention of modern clients. Digital signage offers a
                        dynamic solution to this problem by using eye-catching
                        visuals interactive features and real time updates to
                        deliver messages that connect with your target audience.
                        Whether you are looking forward to promoting your
                        products, sharing important announcements or improving
                        the ambience of your space our digital signage provides
                        you with a versatile platform to achieve your
                        objectives.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
            <div className="row mt-10">
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8">
                <div className="position-relative res-991-pl-0">
                  <div className="about-evant">
                    <div className="prt_single_image-wrapper position-relative z-index-2">
                      <img
                        className="img-fluid"
                        src="./images/digital_welcome_2.webp"
                        alt="Digital Signage Welcome"                        
                      />
                    </div>
                    <div className="marquee-overlay-text">
                      <div className="marquee-block">
                        <div className="marquee style2 overflow-hidden"></div>
                      </div>
                    </div>
                  </div>
                  <div className="marquee-block marquee-overlay-text2">
                    <div className="marquee style2"></div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="">
                  <ScrollAnimation animateIn="zoomIn">
                    <h3 className="sub-title">
                      Transforming your vision to reality
                    </h3>
                    <p style={{ textAlign: "justify" }}>
                      We specialize in delivering best signage solutions
                      tailored to meet your unique requirements. Whether you
                      want to improve your brand presence or you are just an
                      individual seeking creative design solutions, our team is
                      always here to help you at every step of the way. From
                      commercial signage solutions to LED digital displays we
                      offer a huge range of services to meet your unique
                      requirements.
                    </p>
                  </ScrollAnimation>
                  <a
                    className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-dark mt-23 res-1199-mt-10"
                    href="/contactus"
                  >
                    Contact Us
                  </a>
                  <Counter />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          style={{
            marginBottom: "60px",
            backgroundColor: "#081A4C",
            padding: "40px 0",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <h3
              style={{
                fontSize: "40px",
                fontWeight: "900",
                color: "#f7db05",
                marginBottom: "40px",
              }}
            >
              Our Products
            </h3>

            <ul
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px 100px",
                maxWidth: "800px",
                margin: "0 auto",
                padding: 0,
                listStyle: "none",
              }}
            >
              {[
                "Active LED Digital Signage",
                "Kiosk Signage",
                "Commercial Signage",
                "3D Signage",
              ].map((item, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    color: "#f7db05",
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "260px",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      minWidth: "8px",
                      backgroundColor: "#f7db05",
                      borderRadius: "50%",
                    }}
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Workdetails/>
        <Ourwork />
        {magicInfoData.map((item, index) => (
          <MagicInfo
            key={index}
            title={item.title}
            image={item.image}
            reverse={item.reverse}
          />
        ))}
        <InfoSection
          title={InfoSectionData.title}
          cards={InfoSectionData.cards}
        />
      </div>
      <Homesignage />
      
    </>
  );
};
